import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  CustomCheckbox,
  Badge,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useTomada, { LOAD_MESSAGE } from './CadastroTomadaHook'
import TomadaModal from './TomadaModal/TomadaModal'
import parseTomadaStatus from '../../../../constants/tomada-status'
import { tableCellCentered } from '../../../../assets/js/styles'

function CadastroTomada({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useTomada()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox('Carregando tomadas', 'Aguarde...'))
        localDispatch.getTomadas(state.selectedTp)
        break
      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>9.3 - Cadastro de Tomadas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={!!selectedTp}
          onVoltar={history.goBack}
        >
          <DataTable
            header={header}
            value={state.tomadas}
            paginator
            rows={15}
            selectionMode="single"
            onRowClick={e => localDispatch.onRowClick(e.data)}
            globalFilter={state.globalFilter}
            emptyMessage="Nenhuma tomada encontrada"
            dataKey="id"
          >
            <Column field="id" header="Código" style={tableCellCentered()} />
            <Column
              field="numero_referencia"
              header="Número de Referência"
              style={tableCellCentered()}
            />
            <Column field="sequencia" header="Sequência" style={tableCellCentered()} />
            <Column
              field="status"
              header="Status Atual"
              style={tableCellCentered()}
              body={utl => {
                const status = parseTomadaStatus(utl.status)
                return <Badge color={status.color}>{status.label}</Badge>
              }}
              bodyStyle={tableCellCentered()}
            />
            <Column
              header="Ativa"
              body={row => <CustomCheckbox disabled checked={!!row.actived} onChange={() => {}} />}
              style={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>

      <TomadaModal
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CadastroTomada))
